module.exports = __webpack_public_path__ + "static/media/siri34.079821e4.jpg";